import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import axios from 'axios'
import ApiSetting from '../../../../../../Settings/ApiSettings.json'
import Cookies from "universal-cookie";
import swal from "sweetalert";
import Button from "@mui/material/Button";

const cookies = new Cookies();
const language = cookies.get("language") ? cookies.get("language") : "ar";

function HomeAddress({getCurrentReportDataAfterUpdate,object,Access,advanceSearch,section_id,stage_transaction_type_id}) {
   const [homeAddressGovernorate,setHomeAddressGovernorate]=useState(object?.home_address_governorate)
   const [homeAddressDistrict,setHomeAddressDistrict]=useState(object?.home_address_district)
   const [homeAddressTownship,setHomeAddressTownship]=useState(object?.home_address_township)
   const [homeAddressVillage,setHomeAddressVillage]=useState(object?.home_address_village)
   const [homeAddressNumber,setHomeAddressNumber]=useState(object?.home_address_number)
   const [homeAddressNeighborhood,setHomeAddressNeighborhood]=useState(object?.home_address_Neighborhood)
   const [homeAddressLocality,setHomeAddressLocality]=useState(object?.home_address_locality)
   const [homeAddressAlley,setHomeAddressAlley]=useState(object?.home_address_alley)
   const [homeAddressHouse,setHomeAddressHouse]=useState(object?.home_address_house)
   const [loading,setLoading]=useState(false)
   const checkAccessPrivileges =()=>{
    let check=true;
    Access?.map((data)=>{
        if(data==1){
            check=true;
        }else if(data==2||data==3||data==4){
            check=false
        }
    })
    return check;
}

    const checkAccessPrivilegesCanEdit=()=>{
        let check=false;
        Access?.map((data)=>{
            if(data==3){
                check=true;
             }
        })
        return check;
    }
    const checkAccessPrivilegesCanAdd=()=>{
        let check=false;
        Access?.map((data)=>{
            if(data==2){
                check=true;
             }
        })
        return check;
    }
    const updateData=async()=>{
        let data=null;
        setLoading(true);
        try{
            data=await axios({
               method: 'put',
               url:ApiSetting.apiUrl+'/income_tax_report/'+object?.id,
               data:{
                section_name:'3',
                home_address_governorate:homeAddressGovernorate,
                home_address_district:homeAddressDistrict,
                home_address_township:homeAddressTownship,
                home_address_village:homeAddressVillage,
                home_address_number:homeAddressNumber,
                home_address_Neighborhood:homeAddressNeighborhood,
                home_address_locality:homeAddressLocality,
                home_address_alley:homeAddressAlley,
                home_address_house:homeAddressHouse,
                user_id:cookies.get('user_id'),
                role_id:cookies.get('role_id')+1,
                section_id:section_id,
                stage_transaction_type_id:stage_transaction_type_id
               },
               headers:{
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "X-localization": language,
               }
            })
            if(data){
                if(data?.data?.status==200){
                    swal("تم التحديث!", `${data?.data?.message}`, "success");
                    setHomeAddressGovernorate(data?.data?.data?.home_address_governorate);
                    setHomeAddressDistrict(data?.data?.data?.home_address_district);
                    setHomeAddressTownship(data?.data?.data?.home_address_township);
                    setHomeAddressVillage(data?.data?.data?.home_address_village);
                    setHomeAddressNumber(data?.data?.data?.home_address_number);
                    setHomeAddressNeighborhood(data?.data?.data?.home_address_Neighborhood);
                    setHomeAddressLocality(data?.data?.data?.home_address_locality);
                    setHomeAddressAlley(data?.data?.data?.home_address_alley);
                    setHomeAddressHouse(data?.data?.data?.home_address_house);
                    advanceSearch()                    
                    getCurrentReportDataAfterUpdate()

                }else{
                    console.log(data?.data?.message);
                    swal("فشل التحديث!", `${data?.data?.message}`, "warning");

                }
            }
        setLoading(false);

        }catch(err){
            swal("فشل التحديث!", `${err?.message}`, "error");
            setLoading(false);

        }
        
    }

    return (
        <>
            {/*###==> home address here ...  */}
            <h4
                style={{
                    marginRight: "10px",
                    color: "#5f7b8a",
                }}
            >
                عنوان السكن
            </h4>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    flexFlow: "row wrap",

                    border: "1px solid",
                    borderColor: "#5f7b8a",
                    borderRadius: 10,
                    margin: 10,
                    paddingBottom: 10,
                }}
            >
                <div
                    style={{
                        display: "flex",
                        width: "20%",
                        minWidth: 200,
                        marginTop: 10,
                        paddingLeft: 10,
                        paddingTop: 10,
                        paddingRight: 10,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <FormControl fullWidth>
                        <InputLabel id="career-simple-select-label">
                            المحافظة
                        </InputLabel>
                        <Select
                            disabled={checkAccessPrivileges()}
                            labelId="career-simple-select-label"
                            id="career-simple-select"
                            value={homeAddressGovernorate}
                            label="المحافظة "
                            onChange={(e) => {
                                setHomeAddressGovernorate(e.target.value);
                            }}
                        >
                            <MenuItem value={"بغداد"}>{"بغداد"}</MenuItem>
                            <MenuItem value={"بابل"}>{"بابل"}</MenuItem>
                            <MenuItem value={"دهوك"}>{"دهوك"}</MenuItem>
                            <MenuItem value={"الانبار"}>{"الانبار"}</MenuItem>
                            <MenuItem value={"بصر"}>{"بصر"}</MenuItem>
                            <MenuItem value={"ناصرية"}>{"ناصرية"}</MenuItem>
                            <MenuItem value={"ذي قار	"}>{"ذي قار	"}</MenuItem>
                            <MenuItem value={"القادسية"}>{"القادسية"}</MenuItem>
                            <MenuItem value={"ديالى	"}>{"ديالى	"}</MenuItem>
                            <MenuItem value={"حلبجة "}>{"حلبجة "}</MenuItem>
                            <MenuItem value={"كربلاء"}>{"كربلاء"}</MenuItem>
                            <MenuItem value={"كركوك"}>{"كركوك"}</MenuItem>
                            <MenuItem value={"ميسان"}>{"ميسان"}</MenuItem>
                            <MenuItem value={"سليمانية"}>{"سليمانية"}</MenuItem>
                            <MenuItem value={"المثنى"}>{"المثنى"}</MenuItem>
                            <MenuItem value={"النجف"}>{"النجف"}</MenuItem>
                            <MenuItem value={"نينوى"}>{"نينوى"}</MenuItem>
                            <MenuItem value={"صلاح الدين"}>{"صلاح الدين"}</MenuItem>
                        </Select>
                    </FormControl>

                    <Typography className="fontForError">
                        {/* {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.homeAddressGoverNorate) {
                            return err.homeAddressGoverNorate;
                          }
                        })
                      : null} */}
                    </Typography>
                </div>

                <div
                    style={{
                        display: "flex",
                        width: "20%",
                        minWidth: 200,
                        marginTop: 10,
                        paddingTop: 10,
                        paddingLeft: 10,
                        paddingRight: 10,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <FormControl fullWidth>
                        <TextField
                            label="قضاء"
                            InputProps={{
                                readOnly: checkAccessPrivileges(),
                            }}
                            variant="outlined"
                            value={homeAddressDistrict}
                            onChange={(e) => {
                                setHomeAddressDistrict(e.target.value);
                            }}
                        />
                    </FormControl>
                    <Typography className="fontForError">
                        {/* {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.homeAddressDistrict) {
                            return err.homeAddressDistrict;
                          }
                        })
                      : null} */}
                    </Typography>
                </div>

                <div
                    style={{
                        display: "flex",
                        width: "20%",
                        minWidth: 200,
                        marginTop: 10,
                        paddingTop: 10,
                        paddingLeft: 10,
                        paddingRight: 10,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <FormControl fullWidth>
                        <TextField
                            label="ناحية"
                            InputProps={{
                                readOnly: checkAccessPrivileges(),
                            }}
                            variant="outlined"
                            value={homeAddressTownship}
                            onChange={(e) => {
                                setHomeAddressTownship(e.target.value);
                            }}
                        />
                    </FormControl>
                    <Typography className="fontForError">
                        {/* {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.homeAddressTownship) {
                            return err.homeAddressTownship;
                          }
                        })
                      : null} */}
                    </Typography>
                </div>

                <div
                    style={{
                        display: "flex",
                        width: "20%",
                        minWidth: 200,
                        marginTop: 10,
                        paddingTop: 10,
                        paddingLeft: 10,
                        paddingRight: 10,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <FormControl fullWidth>
                        <TextField
                            label="قرية"
                            variant="outlined"
                            value={homeAddressVillage}
                            InputProps={{
                                readOnly: checkAccessPrivileges(),
                            }}
                            onChange={(e) => {
                                setHomeAddressVillage(e.target.value);
                            }}
                        />
                    </FormControl>
                    <Typography className="fontForError">
                        {/* {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.homeAddressVillage) {
                            return err.homeAddressVillage;
                          }
                        })
                      : null} */}
                    </Typography>
                </div>

                <div
                    style={{
                        display: "flex",
                        width: "20%",
                        minWidth: 200,
                        marginTop: 10,
                        paddingTop: 10,
                        paddingLeft: 10,
                        paddingRight: 10,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <FormControl fullWidth>
                        <TextField
                            label="رقم"
                            InputProps={{
                                readOnly: checkAccessPrivileges(),
                            }}
                            variant="outlined"
                            value={homeAddressNumber}
                            onChange={(e) => {
                                setHomeAddressNumber(e.target.value);
                            }}
                        />
                    </FormControl>
                    <Typography className="fontForError">
                        {/* {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.homeAddressNumber) {
                            return err.homeAddressNumber;
                          }
                        })
                      : null} */}
                    </Typography>
                </div>

                <div
                    style={{
                        display: "flex",
                        width: "20%",
                        minWidth: 200,
                        marginTop: 10,
                        paddingTop: 10,
                        paddingLeft: 10,
                        paddingRight: 10,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <FormControl fullWidth>
                        <TextField
                            label="حي"
                            InputProps={{
                                readOnly: checkAccessPrivileges(),
                            }}
                            variant="outlined"
                            value={homeAddressNeighborhood}
                            onChange={(e) => {
                                setHomeAddressNeighborhood(e.target.value);
                            }}
                        />
                    </FormControl>
                    <Typography className="fontForError">
                        {/* {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.homeAddressNeighborhood) {
                            return err.homeAddressNeighborhood;
                          }
                        })
                      : null} */}
                    </Typography>
                </div>

                <div
                    style={{
                        display: "flex",
                        width: "20%",
                        minWidth: 200,
                        marginTop: 10,
                        paddingTop: 10,
                        paddingLeft: 10,
                        paddingRight: 10,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <FormControl fullWidth>
                        <TextField
                            label="محلة"
                            InputProps={{
                                readOnly: checkAccessPrivileges(),
                            }}
                            variant="outlined"
                            value={homeAddressLocality}
                            onChange={(e) => {
                                setHomeAddressLocality(e.target.value);
                            }}
                        />
                    </FormControl>
                    <Typography className="fontForError">
                        {/* {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.homeAddressLocality) {
                            return err.homeAddressLocality;
                          }
                        })
                      : null} */}
                    </Typography>
                </div>

                <div
                    style={{
                        display: "flex",
                        width: "20%",
                        minWidth: 200,
                        marginTop: 10,
                        paddingTop: 10,
                        paddingLeft: 10,
                        paddingRight: 10,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <FormControl fullWidth>
                        <TextField
                            label="زقاق"
                            InputProps={{
                                readOnly: checkAccessPrivileges(),
                            }}
                            variant="outlined"
                            value={homeAddressAlley}
                            onChange={(e) => {
                                setHomeAddressAlley(e.target.value);
                            }}
                        />
                    </FormControl>
                    <Typography className="fontForError">
                        {/* {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.homeAddressAlley) {
                            return err.homeAddressAlley;
                          }
                        })
                      : null} */}
                    </Typography>
                </div>

                <div
                    style={{
                        display: "flex",
                        width: "20%",
                        minWidth: 200,
                        marginTop: 10,
                        paddingTop: 10,
                        paddingLeft: 10,
                        paddingRight: 10,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <FormControl fullWidth>
                        <TextField
                            label="دار"
                            InputProps={{
                                readOnly: checkAccessPrivileges(),
                            }}
                            variant="outlined"
                            value={homeAddressHouse}
                            onChange={(e) => {
                                setHomeAddressHouse(e.target.value);
                            }}
                        />
                    </FormControl>
                    <Typography className="fontForError">
                        {/* {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.homeAddressHouse) {
                            return err.homeAddressHouse;
                          }
                        })
                      : null} */}
                    </Typography>
                </div>

            </div>

            {
                checkAccessPrivilegesCanAdd()||checkAccessPrivilegesCanEdit()?
                <div
                    style={{
                        display: "flex",
                        width:'100%',
                        minWidth: 200,
                        marginTop: 10,
                        paddingTop: 10,
                        paddingLeft: 10,
                        paddingRight: 10,
                        justifyContent: "end",
                        alignItems: "center",
                    }}
                >
                    <Button variant="contained" style={{backgroundColor:"#5f7b8a",paddingLeft:30,paddingRight:30}}
                    onClick={()=>{
                        updateData();
                    }}
                    >
                        {!loading ? (
                        "تحديث"
                    ) : (
                        <div class="spinner-border " role="status">
                        <span class="visually-hidden">Loading...</span>
                        </div>
                    )}
                    </Button>
                </div>:null
           }
        </>

    )
}

export default HomeAddress